module.exports = __webpack_public_path__ + "static/img/prezzta2.03ca0cc7.svg";